import React, {useState} from "react";//useEffect,
import {useAppDispatch, useAppSelector} from "src/store/store";
import {setLicenseData, setStepIncrease} from "src/store/features/licenseSlice";
import Toast from "../../ui/Toast";
import TourButton from "../../TourButton/TourButton";
import Joyride, {STATUS} from "react-joyride";
import {DocumentationLink} from "../../ui/DocumentationLink";

const LicenseValidation = () => {
    const [encrpytedData, setEncrpytedData] = useState("")
    const [toast, setToast] = useState({isSuccess: false, message: "", showToast: false});
    const stepIncrease = useAppSelector(state => state.license.stepIncrease)
    const [state, setState] = useState({
        run: false
    });
    const locale = {
        back: 'Geri',
        close: 'Kapat',
        last: 'Son',
        next: 'İleri',
        skip: "Atla"
    }
    const dispatch = useAppDispatch()
    const licenseKey = useAppSelector((state) => state.license.licenseKey)
    const requestData = {
        licenseKey: licenseKey,
        licenseData: encrpytedData
    }
    const startTour = () => {
        setState({...state, run: true})
    }
    const handleJoyrideCallback = (data: any) => {
        const {status} = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];
        if (finishedStatuses.includes(status)) {
            setState({...state, run: false})
        }
    };
    const activateLicense = async () => {
        await fetch("http://localhost:5452/api/v1/license/hakedis/offlineActivation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(requestData)
        }).then(response => response.json())
            .then(data => {
                if (data.status) {
                    dispatch(setLicenseData(data.data))
                    setToast({message: data.message, showToast: true, isSuccess: true})
                    setTimeout(() => {
                        setToast({...toast, showToast: false})
                    }, 3000);
                    dispatch(setStepIncrease(stepIncrease + 1));
                } else {
                    setToast({message: data.message, showToast: true, isSuccess: false});
                    setTimeout(() => {
                        setToast({...toast, showToast: false});
                    }, 3000);
                }
            })
    }
    return (
        <div>
            <section className="py-14 max-w-screen-xl mx-auto">
                {state.run ?
                    <Joyride
                        continuous
                        callback={handleJoyrideCallback}
                        run={state.run}
                        steps={
                            [
                                {
                                    content: <h2>Lisans Doğrulama rehberi için devam ediniz.</h2>,
                                    placement: "center",
                                    target: "body"
                                },
                                {
                                    content: <h2>Buradaki boş alana HakedişPlus uygulamasından aldığınız kodu
                                        yapıştırınız.</h2>,
                                    placement: "bottom",
                                    target: "#comment"
                                },
                                {
                                    content: <h2>Buradaki butona tıklayarak lisansınızı doğrulayabilirsiniz.</h2>,
                                    placement: "bottom",
                                    target: "#updateButton"
                                }
                            ]
                        }
                        hideCloseButton
                        locale={locale}
                        scrollToFirstStep
                        showSkipButton
                        showProgress/>
                    : ''}
                <div
                    className="w-full p-4 text-center bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-900 dark:shadow-gray-300 dark:border-gray-800 transition-colors duration-300">
                    <div className=" z-10 max-w-xl mx-auto sm:text-center">
                        <div className="space-y-3">
                            <h3 className="text-3xl font-bold">
                                Doğrulama
                            </h3>
                            <br/>
                            <span className="leading-relaxed">
                            HakedişPlus&apos;ı açınız.
                        </span>
                            <br/>
                            <span className="leading-relaxed">
                                <b>Genel İşlemler &gt; Otomasyon Seçenekleri &gt; Lisans Aktifleştirme </b> ekranında size gösterilen kodu aşağıdaki kutucuğa yapıştırın.
                        </span>

                        </div>
                        <div className="mt-6  items-center justify-center rounded-lg p-1">
                            <form onSubmit={e => e.preventDefault()}>
                                <div
                                    className="w-full mb-4 border border-gray-200 rounded-lg bg-gray-100">
                                    <div className="px-4 py-2 bg-white rounded-t-lg ">
                                    <textarea id="comment"
                                              value={encrpytedData}
                                              onChange={e => setEncrpytedData(e.target.value)}
                                              className="w-full h-32 px-0 text-sm text-gray-900 bg-white border-0 "
                                              placeholder="Aktivasyon kodunu buraya yapıştırınız"
                                              required>
                                    </textarea>
                                    </div>
                                    <div
                                        className="flex flex-col items-end px-3 py-2 border-t ">
                                        <button type="submit"
                                                id={'updateButton'}
                                                onClick={activateLicense}
                                                className="right-0  py-2.5 px-4  text-xs font-medium text-center text-white bg-blue-700 rounded-lg focus:ring-4 focus:ring-blue-200 ">
                                            Lisansı Doğrula
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <DocumentationLink/>
                        </div>
                    </div>

                    <Toast message={toast.message} showToast={toast.showToast} isSuccess={toast.isSuccess}/>
                </div>
            </section>
            <TourButton onClick={startTour}/>
        </div>
    )
}
export default LicenseValidation
